// SideMenu.jsx
import * as React from "react";
import { styled } from "@mui/material/styles";
import MuiDrawer, { drawerClasses } from "@mui/material/Drawer";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import MenuContent from "./MenuContent";
import logo1 from "../components/Images/para.png";
import { useSidebar } from "./SidebarContext";

const drawerWidth = 264;
const collapsedWidth = 76;

const GRAY_LINE = "#E7EAF0";
const BG = "#FFFFFF";

const StyledDrawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: open ? drawerWidth : collapsedWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  transition: theme.transitions.create(["width"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.standard,
  }),

  [`& .${drawerClasses.paper}`]: {
    width: open ? drawerWidth : collapsedWidth,
    overflowX: "hidden",
    transition: theme.transitions.create(["width"], {
      easing: theme.transitions.easing.easeInOut,
      duration: theme.transitions.duration.standard,
    }),
    borderRight: `1px solid ${GRAY_LINE}`,
    boxShadow: "2px 0 12px rgba(67,56,202,.04)",
    background: BG,
  },
}));

export default function SideMenu() {
  const { open } = useSidebar();

  return (
    <>
      <StyledDrawer
        variant="permanent"
        open={open}
        sx={{
          display: { xs: "none", md: "block" },
          position: "relative",
          "& .MuiDrawer-paper": { overflow: "hidden" },
          background: BG,
        }}
      >
        {/* Header / Brand — logo only */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            px: open ? 2.25 : 1,
            height: 64,
            background: "#fff",
            borderBottom: `1px solid ${GRAY_LINE}`,
          }}
        >
          {open ? (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1.5,
                minWidth: 0,
                width: "100%",
              }}
            >
              <Box
                sx={{
                  width: 42,
                  height: 42,
                  borderRadius: "10px",
                  overflow: "hidden",
                  flexShrink: 0,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  background: "#fff",
                }}
              >
                <img src={logo1} alt="Paras Road Lines" className="logo-img" />
              </Box>
              <Box sx={{ minWidth: 0 }}>
                <Typography
                  sx={{
                    color: "#333",
                    fontWeight: 800,
                    fontSize: "1.5rem",
                    letterSpacing: "0.5px",
                    lineHeight: 1.2,
                  }}
                >
                  PARAS
                </Typography>
                <Typography
                  sx={{
                    color: "#333",
                    fontWeight: 600,
                    fontSize: "0.68rem",
                    letterSpacing: "1.8px",
                  }}
                >
                  ROAD LINES
                </Typography>
              </Box>
            </Box>
          ) : (
            <Box
              sx={{
                width: 42,
                height: 42,
                borderRadius: "10px",
                overflow: "hidden",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "#fff",
              }}
            >
              <img src={logo1} alt="P" className="logo-img" />
            </Box>
          )}
        </Box>

        {/* Navigation — takes remaining height */}
        <Box
          sx={{
            flex: 1,
            overflowY: "auto",
            overflowX: "hidden",
            py: 1.5,
            background: BG,
          }}
        >
          <MenuContent collapsed={!open} />
        </Box>
      </StyledDrawer>
      <style>{`
        .logo-img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      `}</style>
    </>
  );
}